import { createSlice } from "@reduxjs/toolkit";

export const logEmail = createSlice({
  name: "logEmail",
  initialState: {
    value: false,
  },
  reducers: {
    setLogEmail: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setLogEmail } = logEmail.actions;
export default logEmail.reducer;
